import { openingHoursBuilder } from '../../..';
import { VoiceMessageBuilder } from '../../../settings';
var QueueScheduleBuilder = /** @class */ (function () {
    function QueueScheduleBuilder() {
        this.schedule = {
            offHoursMessage: new VoiceMessageBuilder().build(),
            openingHours: openingHoursBuilder(),
            useSchedule: false,
        };
    }
    QueueScheduleBuilder.prototype.withOpeningHours = function (openingHours) {
        this.schedule.openingHours = openingHours;
        return this;
    };
    QueueScheduleBuilder.prototype.withOffHoursMessage = function (offHoursMessage) {
        this.schedule.offHoursMessage = offHoursMessage;
        return this;
    };
    QueueScheduleBuilder.prototype.withScheduleId = function (scheduleId) {
        this.schedule.scheduleId = scheduleId;
        return this;
    };
    QueueScheduleBuilder.prototype.withUseSchedule = function () {
        this.schedule.useSchedule = true;
        return this;
    };
    QueueScheduleBuilder.prototype.build = function () {
        return this.schedule;
    };
    return QueueScheduleBuilder;
}());
export { QueueScheduleBuilder };
//# sourceMappingURL=queue-schedule.builder.js.map